import * as Screen from "../lib/Screen.js";
import * as libLocation from "../lib/location.ts";
import * as INR from "../INR.ts";
import ApiServer from "../ApiServer.js";
import  {Calendar} from "../lib/fullcalendar/all.ts";
import * as i18n from "../i18n.ts";
import * as FwDatas from "../FwDatas.ts";
import * as calendar_modal from "../calendar/calendar_modal.js";
import * as currentCalendar from "./currentTimetable.ts";

INR.onPage(INR.URL.TIMETABLE_NC,function(){
  var  renewSessionUrl = libLocation.getURLParam("re");
  let 
    params = libLocation.extractParam(renewSessionUrl),
    token = params.Tv || params.v;
  ApiServer.evtncsync(token,null,function(calSharedBean){
      setCurrentTimeTable(calSharedBean.calendar,calSharedBean.syncBean)
  })
  
});


function setCurrentTimeTable(calendar,syncBean){
  let currenttimetable = calendar.timetable;
  document.getElementById('timetableswitch').innerText = currenttimetable.name
  var 
    weeks = currenttimetable.isOneTime?[]:currenttimetable.weeks,
    range = currenttimetable.isOneTime?null:{
      start:weeks[0].start,
      end:weeks[weeks.length-1].end
    };

  currentCalendar.set(new Calendar(document.getElementById("fullcalendar"),{
    initialView:'timeGridWeek',
    locale: i18n.getSelectedLanguage(),
    allDaySlot:false,
    firstDay:currenttimetable.calendarFirstDayOfWeek%7,
    initialDate: currenttimetable.currentDate,
    validRange: range,
    weekends:currenttimetable.showWeekends,
    scrollTime:'08:00:00',
    height:"parent",
    editable: true,
    //buttonText:i18n.get('eventCalendarNav'),
    headerToolbar: false,
    eventDisplay:'block',
    dayHeaderFormat:{ weekday: Screen.isMobileView()?'short':'long' },
    events: function(range, successCallback,failureCallback){
      successCallback(syncBean.updatedCreated.map(function(ev){
        FwDatas.cache(ev);
        ev.calendar = calendar;
        return {
          start:ev.start,
          end:ev.end,
          title:ev.title+'\r\n'+(ev.description?ev.description+'\r\n':''),
          classNames:"fw-pre-line",
          description:ev.description,
          color:typeof ev.color==='function'?ev.color():ev.color,
          id:ev.metaId,
          allDay:ev.allDay,
          editable:ev.editable
        }
      }));
    },
    datesSet:function(info){
      currentCalendar.updateViewSelector(currenttimetable,info)
    },
    selectable:false,
    eventClick: function(obj){
      var 
        id = obj.event.id,
        evtFw = FwDatas.get(id);
      if(evtFw){
        calendar_modal.viewEventDetails(evtFw,true)
      }else{
        ApiServer.webjslog("Fullcalendar click : cannot find "+id+" in cache");
      }
      
    }
  }),currenttimetable);
  currentCalendar.get().render();
  
}
 